"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIME = void 0;
const vue_1 = __importDefault(require("vue"));
const z = __importStar(require("zod"));
const types_1 = require("./types");
const cell_editor_1 = require("./cell-editor");
const cell_formatter_1 = require("./cell-formatter");
const date_1 = require("./date");
const TIME_FORMATTER_CONFIG = types_1.BASE_CONFIG.extend({});
const TIME_EDITOR_CONFIG = types_1.BASE_CONFIG.extend({
    autocomplete: z
        .string()
        .optional()
        .default('off'),
    placeholder: z.string().optional()
});
exports.TIME = {
    name: 'time',
    formatter: {
        schema: TIME_FORMATTER_CONFIG,
        createComponent(config) {
            return {
                minWidth: 75,
                component: {
                    name: 'TimeFormatter',
                    mixins: [cell_formatter_1.CellFormatter],
                    ...vue_1.default.compile('<span class="text-nowrap">{{ value }}</span>')
                }
            };
        }
    },
    editor: {
        schema: TIME_EDITOR_CONFIG,
        createComponent(config) {
            return {
                minWidth: 75,
                component: {
                    name: 'TimeEditor',
                    mixins: [cell_editor_1.CellEditor],
                    ...vue_1.default.compile(`<DatePicker
              input-class="form-control form-control-sm"
              v-model="currentValue"
              v-bind="bindings"
              :autofocus="autofocus"
              :clearable="!col.required"
              :id="col.field"
              :name="col.name"
              :form="formId"
              :tabindex="col.effectiveTabindex"
              :size="col.size"
              :state=validationState
              :disabled="isDisabled"
              @change="onChange($event)"
            ></DatePicker>`),
                    data() {
                        return {
                            bindings: {
                                autocomplete: config.autocomplete,
                                placeholder: config.placeholder,
                                format: 'HH:mm',
                                type: 'time',
                                valueType: 'HH:mm',
                                lang: (0, date_1.getDatepickerLang)(config.lang)
                            }
                        };
                    }
                }
            };
        }
    }
};
//# sourceMappingURL=time.js.map